// Konstanten und Helper für Dokumente.

export const DOKUMENT_TYP_OPTIONS = [
  { value: 'angebot', label: 'Angebot' },
  { value: 'vertrag', label: 'Vertrag' },
  { value: 'rechnung', label: 'Rechnung' },
  { value: 'praesentation', label: 'Präsentation' },
  { value: 'sonstiges', label: 'Sonstiges' },
];

export const DOKUMENT_TYP_LABEL = Object.fromEntries(
  DOKUMENT_TYP_OPTIONS.map((o) => [o.value, o.label])
);

// Distinct Farben — Lila wird für 'rechnung' (zentrale Brand-Aktion) verwendet,
// die anderen unterscheiden sich davon klar.
export const DOKUMENT_TYP_BADGE = {
  angebot: 'bg-amber-100 text-amber-800 ring-amber-200',
  vertrag: 'bg-emerald-100 text-emerald-800 ring-emerald-200',
  rechnung: 'bg-primary-100 text-primary-800 ring-primary-200',
  praesentation: 'bg-orange-100 text-orange-800 ring-orange-200',
  sonstiges: 'bg-slate-100 text-slate-700 ring-slate-200',
};
